export enum AcaoBtnTabelaEnum {
  Inativar = 'inativar',
  Deletar = 'deletar',
  Visualizar = 'visualizar'
}
